<template>
    <div class="account-page">
        <div class="main-wrapper">
            <layout-header></layout-header>
            <div class="content">
                <div class="container">
                    <div class="row align-items-center justify-content-center">
                        <div class="col-md-7 col-lg-6 login-left">
                            <!-- Left Column for Image -->
                            <img :src="'https://develop-physio.kneexpert.in' + ContactusImage" class="img-fluid"
                                alt="Contact Us" loading="lazy" :style="{ display: ContactusImage ? 'block' : 'none' }" style="height: 400px;border-radius:10px;"/>

                        </div>
                        <div class="col-md-12 col-lg-5 mt-1 login-right">
                            <!-- Right Column for Contact Form -->
                            <h3 class="mt-2 mb-3">Contact Us</h3>
                            <form>
                                <input v-model="name" type="text" class="form-control" placeholder="Name" />
                                <br />
                                <input v-model="email" type="email" class="form-control" placeholder="Email" />
                                <br />
                                <textarea v-model="message" class="form-control" placeholder="Message"
                                    :style="{ height: '150px' }"></textarea>
                                <br />
                                <button @click.prevent="submitForm" type="submit"
                                    class="btn btn-primary mb-2">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <layout-footer></layout-footer>
        </div>
    </div>
</template>
  
<script>
import axios from "axios";

export default {
    data() {
        return {
            name: "",
            email: "",
            message: "",
            main_data: "",
            ContactusImage: "",
        };
    },
    mounted() {
        this.get_practitioner_profile();
    },
    methods: {
        submitForm() {
            // Handle form submission logic here
        },
        async get_practitioner_profile() {
            var domain = window.location.hostname;

            const formdata = {
                domain: window.location.hostname,
            };
            await axios
                .get(
                    "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
                    window.location.hostname
                )
                .then((res) => {
                    this.showspinner = false;
                    if (res.data.status_code == 200) {
                        this.main_data = res.data.data[0].header;
                        this.ContactusImage = res.data.data[0].contact_page_image;
                    }
                    if (res.data.status_code == 404) {
                        if (window.location.hostname == "physio.sahajhelp.com") {
                            // Handle specific case
                                   } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
                            // Handle specific case
                        }
                        else if (window.location.hostname.startsWith("192.168")) {
                        } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
                            // Handle specific case
                        } else {
                            window.location.href = String("https://physio.kneexpert.in");
                        }
                    }

                    this.$swal.close();
                });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/kneexpert/Contact_Us.vue